var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2353_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9863 26.5144C42.6673 23.7897 40.8114 21.094 37.8101 21.3265C34.9973 21.559 32.9457 23.964 31.387 26.1947C30.1981 22.7434 26.2036 20.193 22.5571 21.2393C16.511 23.0049 19.4036 31.5642 21.7742 35.1318C24.094 38.5832 27.2475 41.366 30.3721 44.0617C30.4864 44.1265 30.6184 44.153 30.7489 44.1373C30.8793 44.1216 31.0013 44.0646 31.097 43.9745C34.2363 41.6974 37.0572 39.0094 39.4847 35.982C41.5146 33.3589 43.3922 29.9149 42.9863 26.5144Z",
    fill: "#030201"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41868 13.4353C7.17126 10.3908 17.3193 0.483966 31.5349 1.02102C35.2784 1.16397 45.6829 1.26864 53.6347 11.6194C55.5004 14.0497 61.5193 21.8968 60.9994 32.0428C60.1981 47.6404 44.2546 59.1542 31.0024 59.9539C21.6345 60.518 10.5111 55.9164 4.63583 45.3647C3.3513 43.0465 0.867862 38.3599 1.00549 32.0428C1.19511 23.2413 6.41277 14.9847 14.3555 10.3676",
    stroke: "#030201",
    strokeWidth: 0.831797,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2353_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0829,
    height: 23.1567,
    fill: "white",
    transform: "translate(18.9619 21)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.0cb2a2c0e565b4e8ab63806988431d1a.svg";
export { ForwardRef as ReactComponent };